import { AUTH_KEY, USER_KEY, PASSWORD } from './constants';

export function isAuthenticated() {
  return localStorage.getItem(AUTH_KEY) === 'ok';
}

export function getCurrentUser() {
  return localStorage.getItem(USER_KEY) || '';
}

export function login(password) {
  if (password === PASSWORD) {
    localStorage.setItem(AUTH_KEY, 'ok');
    return true;
  }
  return false;
}

export function setCurrentUser(name) {
  localStorage.setItem(USER_KEY, name);
}
